export const FIRST_MESSAGE_MODE_OPTIONS = [
    {
      label: 'Assistant speaks first',
      value: 'assistant-speaks-first'
    },
    {
      label: 'Assistant waits for user',
      value: 'assistant-waits-for-user'
    },
    {
      label: 'Assistant speaks first with model generated message',
      value: 'assistant-speaks-first-with-model-generated-message'
    }
  ];
  
  export const BACKGROUND_SOUNDS_OPTIONS = [
    {
      label: 'Of',
      value: 'off'
    },
    {
      label: 'Office',
      value: 'office'
    }
  ];